import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody, formatGraphqlParams } from '@/utils'

export default {
    create(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    createErpUser (
                        user_id: ${data.user_id},
                        erp_id: ${data.erp_id},
                        user_integration_name: "${data.user_integration_name}",
                        user_integration_id: ${data.user_integration_id},
                    ) {
                        id,
                        user_id,
                        erp_id,
                        user_integration_name,
                        user_integration_id
                    }
                }
            `
        })
    },   
    delete(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteErpUser (
                        id: ${id}
                    )
                }
            `
        })
    }, 
    fetch(erpId, word = null, sortName = "name", orderBy = "ASC", id = null, page = 1, itemsPerPage = 4) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';

        return axios.post('', formatGraphqlBody(
            'query',
            'paginatedErpUser',
            {
                0: 'pagination_page',
                1: 'pagination_limit',
                2: 'total_pages',
                3: 'total_items',
                items: {
                    0: 'codigo',
                    1: 'nome',
                    2: 'numeroCpf',
                    3: 'cep',
                    4: 'email',
                    5: 'ativo',
                },
                erp: {
                    0: 'id',
                    1: 'corporate_name',
                    2: 'cnpj',
                    3: 'erp_name',
                    4: 'erp_id',
                }
            },
          id !== null
            ? { id, pagination_page: page, pagination_limit: itemsPerPage, search_filter: word, orderBy: [sortName, orderBy], erp_id: erpId }
            : { pagination_page: page, pagination_limit: itemsPerPage, search_filter: word, orderBy: [sortName, orderBy], erp_id: erpId}
        ))
    },
    fetchWithUserId(userId) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
          query: `
            query {
              getErpUser(user_id: ${userId}) {
                id
                user_id
                user_integration_name
                user_integration_id
                erp {
                  id
                  corporate_name
                  cnpj
                  erp_name
                  erp_id
                }
              }
            }
          `
        });
      }      
}
